import { Observable } from "rxjs";
import { FlyerTemplate } from "../types/flyer-template/flyer-template.interface";
import * as http from "../../../../../services/http.service";
import { map } from "rxjs/operators";
import { SearchResults } from "../../../../../types/search/search-results.interface";
import { FlyerTemplateSummary } from "../types/flyer-template-summary.interface";
import { FlyerTemplateResponse } from "../types/flyer-template-response/flyer-template-response.interface";
import { mapFlyerTemplateResponseToTemplate } from "../types/flyer-template-response/flyer-template-response.functions";

export function fetchAllTemplates(): Observable<FlyerTemplateSummary[]> {
  return http
    .get<SearchResults<FlyerTemplateSummary>>(`/page-templates/`)
    .pipe(map((response) => response.results));
}

export function fetchTemplate(templateId: number): Observable<FlyerTemplate> {
  return http
    .get<FlyerTemplateResponse>(`/page-templates/${templateId}/`)
    .pipe(map(mapFlyerTemplateResponseToTemplate));
}
